import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MobileMeasurements from '../components/MobileMeasurements';
import { RootState } from '../store';
import { Orientation, WriteDirection, Platform } from 'sofa-reborn-react';

const MobileMeasurementsContainer: FC = () => {
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const measurements = useSelector<RootState, string>(
		(state) => state.scene.measurements as string
	);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);

	const isMeasurements: boolean = measurements ? measurements.length > 0 : false;
	const footerHeight = useSelector<RootState, number>(
		(state) => state.application.footerHeight as number
	);

	const [toolsBottom, setToolsBottom] = useState(0);

	const getToolsBottom = (footerHeight: number): void => {
		setToolsBottom(footerHeight - 88 + 205);
	};

	useEffect(() => {
		getToolsBottom(footerHeight);
	}, [footerHeight]);

	return (
		<>
			{isMeasurements && (
				<MobileMeasurements
					platform={platform}
					toolsBottom={toolsBottom}
					measurements={measurements}
					orientation={orientation}
					writeDirection={writeDirection}
				/>
			)}
		</>
	);
};
export default MobileMeasurementsContainer;
